//import os from 'os';
//export const BACKEND_ENDPOINT = 'http://localhost:8000';
export const BACKEND_ENDPOINT = 'https://chatbot-backend-355555758069.europe-west2.run.app';
export const CLIENTID = '355555758069-d1al3lb9s6l083fm0f9c400e9fsin435.apps.googleusercontent.com';

//export const JWT_SECRET = os.environ["JWT_SECRET"];
//export const GOOGLE_APPLICATION_CREDENTIALS = os.environ["GOOGLE_APPLICATION_CREDENTIALS"];
//export const GOOGLE_API_KEY = os.environ["GOOGLE_API_KEY"];
//export const GOOGLE_CLIENT_ID = os.environ["GOOGLE_CLIENT_ID"];
